<style lang="scss" scoped>
.btn-transparent {
  padding-right: 1em
}
</style>

<template>
  <form v-if="!resetPassword" @submit.prevent="login()">
    <div
      v-if="$route.meta.hasLogo"
      class="login-form__custom-logo"
    >
      <img
        :src="require(`@/assets/img/custom-registration-logos/${$route.meta.image}`)"
      />
    </div>

    <dr-field
      v-for="(field, name) in form"
      :key="name"
      :validators.sync="$v.form[name]"
      :field="field"
      :apiErrors.sync="apiErrors[field]"
      :showPasswordIcon="field.showPassword"
      :disabled.sync="resending"
    />

    <transition name="fade">
      <dr-captcha
        v-if="loginAttempts >= 3"
        ref="login-captcha"
        class="login__captcha"
        @on-check="isCaptchaSuccessful = true"
      />
    </transition>

    <div class="flex-space_between">
      <dr-submit
        :disabled="$v.$invalid || (loginAttempts >= 3 && !isCaptchaSuccessful) || resending"
        :sending="sending"
        text="Entrar"
      />

      <a
        class="btn btn-transparent"
        @click="$router.push(registerRoute)"
      >
        Criar conta
      </a>
    </div>

    <p class="text-center">
      <br />
      <router-link
        to="/login/recovery"
        class="flex-center"
      >
        Esqueci minha senha
      </router-link>
    </p>
  </form>
</template>

<script>
import { form, validations } from '@/data/formData/login.js'
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import DrCaptcha from '@/components/form/recaptcha'
import VueJwtDecode from 'vue-jwt-decode'

export default {
  name: 'DrLoginForm',

  props: ['active', 'resetPassword'],

  components: {
    drField,
    drSubmit,
    DrCaptcha
  },

  validations: {
    form: validations
  },

  data () {
    return {
      form: form,
      resending: false,
      sending: false,
      loginAttempts: 0,
      isCaptchaSuccessful: false,
      apiErrors: {
        password: []
      }
    }
  },

  computed: {
    registerRoute () {
      if ('customRegisterRoute' in this.$route.meta) {
        return {
          name: this.$route.meta.customRegisterRoute,
          params: this.$route.params
        }
      }

      return { name: 'RegisterSimpleRegistration' }
    }
  },

  mounted () {
    this.form.user.value = ''
    this.form.password.value = ''

    if ('fn' in this.$route.meta) {
      this.$route.meta.fn(this.$route.params, this)
    }
  },

  destroyed () {
    this.loginAttempts = 0
  },

  methods: {
    login () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const data = {
        _username: this.form.user.value,
        _password: this.form.password.value
      }

      this.sending = true
      this.fn_SHOW_PROGRESS()
      this.$http
        .post('/login_check', data)
        .then((res) => {
          const roles = VueJwtDecode.decode(res.data.token).roles
          if (roles.length === 0 || !roles.find((v) => { return v.search(/DOCTOR|SECRETARY/g) })) {
            this.$store.dispatch('setModalAlert', {
              title: 'Erro de acesso',
              body: 'Erro no Perfil de usuário',
              size: 'md',
              active: true
            })
            this.sending = false
            return false
          }

          this.$store.dispatch('setAuth', res.data)

          const role = roles.indexOf('ROLE_SECRETARY') > -1
            ? 'secretary/doctor_select'
            : 'doctor/'
          this.sending = 2
          this.$emit('success', role)
        })
        .catch((err) => {
          this.$emit('success', false)
          this.sending = false

          const title = (err.code >= 400 && err.code < 500) ? 'Erro de autenticação' : null
          const body = err.message.message ? err.message.message : err.message

          const action = err.code === 405 ? 'setModalConfirm' : 'setModalAlert'

          const modal = err.code === 405
            ? {
              title,
              body,
              confirmText: 'Reenviar e-mail de confirmação',
              cancelText: 'Cancelar',
              beforeClose: (v) => {
                if (v) {
                  this.resendConfirmationEmail(this.form.user.value)
                }

                this.$store.dispatch('setModalConfirm')
              },
              size: 'md2',
              active: true
            }
            : { title, body, size: 'md', active: true }

          this.$store.dispatch(action, modal)

          this.loginAttempts++
          if (this.loginAttempts > 3) {
            this.$refs['login-captcha'].resetRecaptcha()
            this.isCaptchaSuccessful = false
          }
        })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
        })
    },

    resendConfirmationEmail (email) {
      const url = '/doctor/register/resend_confirmation_email'
      const data = {
        'resend_email_confirmation': {
          email
        }
      }

      this.resending = true
      this.fn_SHOW_PROGRESS()
      this.$http
        .post(url, data)
        .then((res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'O e-mail de confirmação foi reenviado com sucesso.',
            size: 'md',
            active: true
          })
        })
        .catch(err => this.fn_HANDLE_ERROR(err))
        .finally(() => {
          this.form.user.value = ''
          this.form.password.value = ''

          this.$v.$reset()

          this.resending = false
          this.fn_HIDE_PROGRESS()
        })
    }
  }
}
</script>
